import clsx from 'clsx';
import { memo } from 'react';

import { useDrawStore } from '@apps/draw/store';
import { useDrawVideoPlayerOptions } from '@apps/draw-centre/hooks';
import { useDrawCentreOptions } from '@apps/draw-centre/store';
import SlotIncluder from '@shared/SlotIncluder';

import * as styles from './styles.module.scss';

const DrawArticle = () => {
  const {
    options: { isDrawArticleAvailable },
  } = useDrawCentreOptions();
  const { drawNoVideo } = useDrawVideoPlayerOptions();

  const draw = useDrawStore((state) => state.draw);

  if (!isDrawArticleAvailable) return;

  return (
    <SlotIncluder
      className={clsx(!drawNoVideo && styles.drawArticle)}
      path={`/${window.competitionUrl}/draws/${draw.seasonYear}/${draw.rounds[0].roundId}/libraries/_draw_article`}
    />
  );
};

export default memo(DrawArticle);
